<template>
<section id="testimonials-ocean" >
    <svg viewBox="0 0 1440 500" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <path id="wave" width="100%" d="M0.828857 1159.45 V481.272 C200.412 550.155 399.996 619.038 615.829 595.205 C831.662 571.372 1063.75 454.823 1245.83 473.134 C1427.91 491.445 1560 644.615 1744.16 668.448 C1928.33 692.281 2164.58 586.777 2400.83 481.272 V1159.45 H0.828857 Z" fill="#3987D8"/>
    </svg>
</section>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
#wave {
    position: absolute;
    left: 0;
    width: 100%;
    animation: waveAnim 10s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
}
// rect {
//     width: 100%;
//     height: 200px;
//     background: #3987d8;
// }
@keyframes waveAnim {
    0%{
        d: path("M 0,500 C 0,500 0,250 0,250 C 119.75,275.3928571428571 239.5,300.7857142857143 369,292 C 498.5,283.2142857142857 637.75,240.25 747,247 C 856.25,253.75 935.5,310.2142857142857 1046,319 C 1156.5,327.7857142857143 1298.25,288.8928571428571 1440,250 C 1440,250 1440,500 1440,500 Z");
    }
    25%{
        d: path("M 0,500 C 0,500 0,250 0,250 C 129.89285714285714,270.3571428571429 259.7857142857143,290.7142857142857 378,284 C 496.2142857142857,277.2857142857143 602.7499999999999,243.5 702,241 C 801.2500000000001,238.5 893.2142857142858,267.2857142857143 1015,274 C 1136.7857142857142,280.7142857142857 1288.392857142857,265.3571428571429 1440,250 C 1440,250 1440,500 1440,500 Z");
    }
    50%{
        d: path("M 0,500 C 0,500 0,250 0,250 C 125.46428571428572,231.67857142857144 250.92857142857144,213.35714285714286 374,204 C 497.07142857142856,194.64285714285714 617.7499999999999,194.25000000000003 745,225 C 872.2500000000001,255.74999999999997 1006.0714285714284,317.64285714285717 1123,327 C 1239.9285714285716,336.35714285714283 1339.9642857142858,293.17857142857144 1440,250 C 1440,250 1440,500 1440,500 Z");
    }
    75%{
        d: path("M 0,500 C 0,500 0,250 0,250 C 103.14285714285714,304.25 206.28571428571428,358.5 314,342 C 421.7142857142857,325.5 533.9999999999999,238.25 674,236 C 814.0000000000001,233.75 981.7142857142858,316.5 1114,333 C 1246.2857142857142,349.5 1343.142857142857,299.75 1440,250 C 1440,250 1440,500 1440,500 Z");
    }
    100%{
        d: path("M 0,500 C 0,500 0,250 0,250 C 119.75,275.3928571428571 239.5,300.7857142857143 369,292 C 498.5,283.2142857142857 637.75,240.25 747,247 C 856.25,253.75 935.5,310.2142857142857 1046,319 C 1156.5,327.7857142857143 1298.25,288.8928571428571 1440,250 C 1440,250 1440,500 1440,500 Z");
    }
}
@media (max-width: 1600px) {
    #testimonials-ocean {
        margin-top: -16vh;
    }
}
@media (max-width: 1200px) {
    #testimonials-ocean {
        margin-top: -18vh;
    }
}
@media (max-width: 992px) {
    #testimonials-ocean {
        margin-top: -28vh;
    }
}
@media (max-width: 768px) {
    #testimonials-ocean {
        margin-top: -34vh;
    }
}
@media (max-width: 576px) {
    #testimonials-ocean {
        margin-top: -42vh;
    }
}
</style>
